import PropTypes from "prop-types"
import React from "react"
import classNames from "classnames"
import "./BraceletIntroBox.scss"
import { useI18nContext } from "i18n/i18n-react"

function BraceletIntroBox(props) {
  const { className } = props
  const { LL } = useI18nContext()
  const infoClasses = classNames(
    "bracelet-intro-box",
    "fadein",
    "text-center",
    className
  )
  return (
    <div className={infoClasses}>
      <h1 className="linotype-didot-font">{LL.bracelets.introHeadline()}</h1>
      <p className="intro-description">{LL.bracelets.introDescription()}</p>
    </div>
  )
}

BraceletIntroBox.propTypes = {
  className: PropTypes.string,
}

export default BraceletIntroBox
